<template>
  <div class="srm-header">
    <div class="srm-header-content">
      <!-- 左侧区域 -->
      <div class="header-menus">
        <!-- 图标区域 -->
        <div class="header-menus-logo">
          <img src="@/assets/logo.jpg" alt="" style="width: 120px;">
        </div>
        <!-- 菜单区域 -->
        <div class="header-menus-items">
          <div class="header-menus-items-name" @click="changeRoute(item)" :class="item.name == currentPath? 'active':''" v-for="item in menuData" :key="item.name">{{item.label}}</div>
        </div>
      </div>
      <div class="header-btn">
        <div class="header-btn-title"> <a href="#">企业官网</a> </div>
        <div class="header-btn-title active-btn" @click="handleContact">产品体验</div>
      </div>
    </div>
    <registerDialog :show.sync="show"/>
  </div>
</template>

<script>
import registerDialog from './register-dialog'
export default {
  components: {registerDialog},
  data () {
    return {
      menuData: [
        { label: '首页', name: 'home' },
        { label: '产品', name: 'product' },
        { label: '服务', name: 'service' },
        { label: '客户案例', name: 'customerCase' },
        { label: '关于我们', name: 'aboutUs' }
      ],
      currentPath: '',
      show: false
    }
  },
  watch: {
    $route: {
      handler (to) {
        this.currentPath = to.name
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeRoute (item) {
      if (item.name === this.currentPath) return
      this.$router.push({name: item.name})
    },
    handleContact () {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.srm-header{
  width: 100%;
  background-color: #fff;
  height: 56px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 3;
  .srm-header-content{
    height: 100%;
    margin: 0 auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-menus{
      display: flex;
      align-items: center;
      .header-menus-logo{
        width: 146px;
        height:31px ;
        margin-right: 16px;
      }
      .header-menus-items{
        display: flex;
        .header-menus-items-name{
          margin-left: 50px;
          cursor: pointer;
          &:hover{
            color: #1989fa;
          }
        }
        .active{
          color: #1989fa;
        }
      }
    }
    .header-btn{
      display: flex;
      .header-btn-title{
        margin-left: 24px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
      .header-btn-title{
        a{
          color: #333;
          text-decoration: none;
          &:hover{
            color: #1989fa;
          }
        }
      }
      .active-btn{
        width: 104px;
        background: #0C55DD;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/srm-header.vue